import { render, staticRenderFns } from "./corp-staff-modal.vue?vue&type=template&id=a070ba98&scoped=true&"
import script from "./corp-staff-modal.vue?vue&type=script&lang=js&"
export * from "./corp-staff-modal.vue?vue&type=script&lang=js&"
import style0 from "./corp-staff-modal.vue?vue&type=style&index=0&id=a070ba98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a070ba98",
  null
  
)

export default component.exports